import { colord } from 'colord';
import { useState } from 'react';

import './HuePicker.css';

const DEFAULT_HUE_COLOR = '#B2C4CE';
const HUE_MAX = 359;

interface HuePickerProps {
  value?: string;
  onChange?: (value: string) => void;
  className?: string;
}

export default function HuePicker({
  value,
  onChange,
  className,
}: HuePickerProps) {
  const isControlled = value !== undefined;
  const controlledHue = colorToHue(value ?? DEFAULT_HUE_COLOR);
  const [internalHue, setInternalHue] = useState(controlledHue);
  const hue = isControlled ? controlledHue : internalHue;

  const handleChange = (nextHue: number) => {
    if (!isControlled) {
      setInternalHue(nextHue);
    }

    onChange?.(hueToHex(nextHue));
  };

  return (
    <div className={`cartwhl-hue-picker ${className ?? ''}`}>
      <input
        aria-label="Hue"
        className="cartwhl-hue-picker__input"
        max={HUE_MAX}
        min={0}
        style={{ color: hueToHex(hue) }}
        type="range"
        value={hue}
        onChange={(event) => handleChange(Number(event.target.value))}
      />
    </div>
  );
}

function colorToHue(color: string) {
  const hsl = colord(color).toHsl();
  return Math.min(HUE_MAX, Math.max(0, Math.round(hsl.h)));
}

function hueToHex(hue: number) {
  return colord({ h: hue, s: 100, l: 50 }).toHex();
}
